import aaron from "../images/aaron-bitmoji.png";
import alec from "../images/alec-bitmoji.png";
import andy from "../images/andy-bitmoji.png";
import angela from "../images/angela-bitmoji.png";
import brian from "../images/brian-bitmoji.png";
import brianf from "../images/brianf-bitmoji.png";
import daylon from "../images/daylon-bitmoji.png";
import dhruv from "../images/dhruv-bitmoji.png";
import dustin from "../images/dustin-bitmoji.png";
import elian from "../images/elian-bitmoji.png";
import james from "../images/james-bitmoji.png";
import jason from "../images/jason-bitmoji.png";
import jennifer from "../images/jennifer-bitmoji.png";
import kathleen from "../images/kathleen-bitmoji.png";
import katie from "../images/katie-bitmoji.png";
import liuliu from "../images/liuliu-bitmoji.png";
import mario from "../images/mario-bitmoji.png";
import matt from "../images/matt-bitmoji.png";
import max from "../images/max-bitmoji.png";
import nathan from "../images/nathan-bitmoji.png";
import neil from "../images/neil-bitmoji.png";
import nick from "../images/nick-bitmoji.png";
import oscar from "../images/oscar-bitmoji.png";
import pavel from "../images/pavel-bitmoji.png";
import remy from "../images/remy-bitmoji.png";
import spacelove from "../images/spacelove-bitmoji.png";
import stephanie from "../images/stephanie-bitmoji.png";
import taylor from "../images/taylor-bitmoji.png";
import tim from "../images/tim-bitmoji.png";
import vinai from "../images/vinai-bitmoji.png";
import zach from "../images/zach-bitmoji.png";

export default function getAuthorImgSrc(name: string): string | undefined {
  switch (name) {
    case "Tim Sehn":
      return tim;
    case "Aaron Son":
      return aaron;
    case "Andy Arthur":
      return andy;
    case "Brian Hendriks":
      return brian;
    case "Daylon Wilkins":
      return daylon;
    case "Dustin Brown":
      return dustin;
    case "Katie McCulloch":
      return katie;
    case "Matt Jesuele":
      return matt;
    case "Oscar Batori":
      return oscar;
    case "Taylor Bantle":
      return taylor;
    case "Zach Musgrave":
      return zach;
    case "Vinai Rachakonda":
      return vinai;
    case "Remy Ochei":
      return remy;
    case "Max Hoffman":
      return max;
    case "Brian Fitzgerald":
      return brianf;
    case "Spacelove":
      return spacelove;
    case "Jennifer Purevsuren":
      return jennifer;
    case "Kathleen Young":
      return kathleen;
    case "James Cor":
      return james;
    case "Liu Liu":
      return liuliu;
    case "Dhruv Sringari":
      return dhruv;
    case "Alec Stein":
      return alec;
    case "Jason Fulghum":
      return jason;
    case "Mario Lopez":
      return mario;
    case "Pavel Safronov":
      return pavel;
    case "Stephanie You":
      return stephanie;
    case "Neil Macneale":
      return neil;
    case "Nick Tobey":
      return nick;
    case "Nathan Gabrielson":
      return nathan;
    case "Angela Xie":
      return angela;
    case "Elian Deogracia-Brito":
      return elian;
    default:
      return undefined;
  }
}
